export const DARK_DESIRE_MAX = 0.95;
